import React from 'react';

const ChatListItem = ({ chatItem, isSelected, onClick }) => {
  // Extract data from the API response
  const { other_member, chat } = chatItem;
  const { first_name, last_name, image_path } = other_member;
  const { last_message_at, last_chat_message } = chat;
  
  // Format the display name
  const displayName = `${first_name} ${last_name}`;
  
  // Create initials for the avatar fallback
  const initials = first_name?.charAt(0).toUpperCase() + last_name?.charAt(0).toUpperCase();
  
  // Format the timestamp to a user-friendly format
  const time = formatTimestamp(last_message_at);
  
  // Handle the message display based on type
  let displayMessage = last_chat_message?.message || '';
  let isNeedsAttention = false;
  let isUnread = false; // Future implementation for unread messages
  
  if (last_chat_message?.msg_type === 'needs_attention') {
    displayMessage = "Needs Attention";
    // Check if the attention request is still active (neither resolved nor revoked)
    isNeedsAttention = last_chat_message.attention_completion_status === null;
  }

  return (
    <li 
      onClick={onClick}
      className={`border-b border-gray-200 hover:bg-gray-100 cursor-pointer
        ${isSelected ? 'bg-gray-200' : ''}
      `}
    >
      <div className="flex p-3">
        <div className="mr-3">
          {image_path ? (
            <img 
              src={image_path} 
              alt={displayName}
              className="w-12 h-12 rounded-full object-cover"
            />
          ) : (
            <div 
              className="w-12 h-12 rounded-full bg-gray-700 text-white flex items-center text-xl justify-center font-medium"
            >
              {initials}
            </div>
          )}
        </div>
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <span className="font-medium">{displayName}</span>
            <span className="text-xs text-gray-500">{time}</span>
          </div>
          <div className="flex justify-between items-center">
            <p className={`text-sm truncate max-w-[75%] ${
              isNeedsAttention ? 'text-red-600 font-medium' : 'text-gray-500'
            }`}>
              {displayMessage}
            </p>
            {isUnread && (
              <div className="bg-blue-600 rounded-full min-w-[20px] h-5 flex items-center justify-center">
                <span className="text-xs text-white font-bold">
                  1
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

// Helper function to format the timestamp
function formatTimestamp(timestamp) {
  if (!timestamp) return '';
  
  const messageDate = new Date(timestamp);
  const now = new Date();
  const diffMs = now - messageDate;
  const diffMins = Math.round(diffMs / 60000);
  const diffHours = Math.round(diffMs / 3600000);
  const diffDays = Math.round(diffMs / 86400000);
  
  // Less than an hour
  if (diffMins < 60) {
    return diffMins <= 1 ? 'Just now' : `${diffMins}m ago`;
  }
  
  // Less than a day
  if (diffHours < 24) {
    return `${diffHours}h ago`;
  }
  
  // Less than a week
  if (diffDays < 7) {
    return diffDays === 1 ? 'Yesterday' : `${diffDays}d ago`;
  }
  
  // Older messages
  return messageDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export default ChatListItem;
